var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSalesLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.49609,
    width: 4,
    height: 38,
    rx: 2,
    fill: "#FF8D3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 0.496094,
    width: 4,
    height: 39,
    rx: 2,
    fill: "#FF8D3F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.49609,
    width: 4,
    height: 34,
    rx: 2,
    fill: "#FF8D3F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15.4961,
    width: 4,
    height: 24,
    rx: 2,
    fill: "#FF8D3F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 11.4961,
    width: 4,
    height: 28,
    rx: 2,
    fill: "#FF8D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSalesLine);
export default __webpack_public_path__ + "static/media/total-sales-line.cedaf7d6ddde7a7114a371c0bfe0ae3b.svg";
export { ForwardRef as ReactComponent };